<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <category-card
        v-for="category in categories"
        :key="category.title"
        :value="category"
      />
    </v-layout>
  </v-container>
</template>

<script>
import CategoryCard from "@/components/CategoryCard";
import { mapGetters } from "vuex";

export default {
  name: "Categories",

  components: {
    CategoryCard
  },

  computed: {
    ...mapGetters(["categories"])
  }
};
</script>
